

import { Outlet } from "react-router-dom";

import LinearLayout from "../../components/layout/LinearLayout";

import Sidebar from "./Sidebar";

import SidebarMobile from "./SidebarMobile";
import useDynamicTabTitle from "../../useDynamicTabTitle";
export default function Dashboard() {
  useDynamicTabTitle("Dashboard");
  return (
    <>
      <SidebarMobile />
      <LinearLayout
        bgcolor="dark"
        orientation="horizontal"
        height="match-parent"
        width="vh-100"
      >
        <Sidebar className="h-100" />

        <LinearLayout
          bgcolor="white card"
          orientation="vertical"
          height="match-parent"
          width="match-parent"
          className="mx-lg-1 overflow-auto"
        >
          <LinearLayout
            height="match-parent"
            width="match-parent"
            xgravity="start"
            className="overflow-auto "
          >
            <div
              className="flex-fill overflow-auto"
              style={{ width: "100%", overflowX: "auto" }}
            >
              <Outlet />
            </div>
          </LinearLayout>
        </LinearLayout>
      </LinearLayout>
    </>
  );
}
